import api from './api';

/** Deals that need a call: { count, overdue, today, unscheduled, items }. */
export const getFollowUps = ({ scope = 'all' } = {}) =>
    api.get('/ProjectAcquisition/follow-ups', { params: { scope } }).then(res => res.data);

/** Log a touchpoint and what it changed — follow-up date, stage, loss reason — in one request: a
 *  call without a scheduled next step is how a pipeline goes stale. */
export const logDealCall = (acquisitionId, {
    type = 'call',
    content,
    nextFollowUpDate,
    clearFollowUp,
    status,
    lostReason,
}) =>
    api.post(`/ProjectAcquisition/${acquisitionId}/activities`, {
        type,
        content,
        next_follow_up_date: nextFollowUpDate || null,
        clear_follow_up: Boolean(clearFollowUp),
        ...(status ? { status } : {}),
        ...(lostReason ? { lost_reason: lostReason } : {}),
    }).then(res => res.data);
